import {
  BookkeepingTagDbValue,
  BookkeepingTagNavItemValue,
  convertBookkeepingTagDbValueToNavItemValue,
  isBookkeepingTagValid,
} from '@components'

import { Badge, Color, Icon, SkeletonBox, Space } from '@billy/design-system'
import React, { ReactElement, useState } from 'react'
import { useAsync } from 'react-use'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getCurrentLocale } from '../../../../../../utils'
import * as Styled from './styles'

interface BillBookkeepingTagProps {
  bookkeepingTag: BookkeepingTagDbValue
}

export const BillBookkeepingTag = ({ bookkeepingTag }: BillBookkeepingTagProps): ReactElement | null => {
  const [isFetchingTag, setFetchingTag] = useState(true)
  const locale = getCurrentLocale()
  const [bookkeepingTagValue, setBookkeepingTagValue] = useState<BookkeepingTagNavItemValue>()
  const { organization } = useUserOrganization()

  useAsync(async () => {
    if (!organization?.id) {
      return
    }

    const bookkeepingTagValue = await convertBookkeepingTagDbValueToNavItemValue({
      dbValue: bookkeepingTag,
      locale,
      organizationId: organization.id,
    })

    if (bookkeepingTagValue && isBookkeepingTagValid(bookkeepingTagValue)) {
      setBookkeepingTagValue(bookkeepingTagValue)
    }

    setFetchingTag(false)
  }, [bookkeepingTag, organization?.id])

  if (!isFetchingTag && !bookkeepingTagValue) {
    return null
  }

  return (
    <Styled.BillBookkeepingTagWrapper>
      {isFetchingTag ? <SkeletonBox height={20} width={75} /> : <Badge>{bookkeepingTagValue?.tag?.name}</Badge>}
      <Space size="s4" horizontal />
      <Icon icon="chevronRight" color={Color.Black} size="xs" />
      <Space size="s4" horizontal />
      {isFetchingTag ? <SkeletonBox height={20} width={200} /> : <Badge>{bookkeepingTagValue?.response?.name}</Badge>}
    </Styled.BillBookkeepingTagWrapper>
  )
}
